module.exports = __webpack_public_path__ + "media/images/icon-filter-device-fdbf4d84e2ca8ac0ccc3595a04d505c8.png";